import { PathParams } from '@app/routes/types';

/**
 * @todo Refactor this file after @gabe's PR: 2577 so we have a consistent template.
 * Also, another major change to make will be replacing :groupId across board, but
 * this is not mission critical, so we can keep it for a quiet time.
 */

// Base
export const GROUP_HOME = '/home';
export const GROUP_BASE = '/pods';

// Single pages
export const GROUP_SINGLE = `:${PathParams.GroupId}`;
export const GROUP_SINGLE_INVITE_ACCEPT = `:${PathParams.GroupId}/invites/:${PathParams.Id}/accept`;
export const GROUP_SINGLE_MEMBERS = `:${PathParams.GroupId}/members`;
export const GROUP_INVITE_WELCOME = `:${PathParams.GroupId}/welcome`;

// Invites
export const GROUP_INVITE_LANDING = `/invites/:${PathParams.InviteCode}`;
export const GROUP_INVITE_CREATE_ACCOUNT = '/invites/create-account';
export const GROUP_INVITE_CONFIRM_ACCOUNT = '/invites/confirm-account';
export const GROUP_INVITE_FREE_YAT = '/invites/free-yat';
